<template>
  <div class="chart-block">
    <h3>
       <a :href="url" target="_blank"> {{chartName}}</a>
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div v-html="tip" slot="content"></div>
        <svg-icon name="faq" size="20" @click.native="faq()" color="#53b1e7"></svg-icon>
      </el-tooltip>
      <span>{{updated}}</span>

      <el-radio-group
        v-model="marketType"
        size="mini"
        class="opt"
        @change="bindChart()"
        :disable="loading"
      >
        <el-radio-button label="新四化整体"></el-radio-button>
        <el-radio-button label="电动化"></el-radio-button>
        <el-radio-button label="网联化"></el-radio-button>
        <el-radio-button label="智能化"></el-radio-button>
      </el-radio-group>
    </h3>
    <div id="chart_btms" class="chart-box" v-loading="loading"></div>
  </div>
</template>
<script>
import echarts from "echarts";
 import {strToYeayAndMonth } from '@/plugins/DateTimeFormater.js';
    import {
        mapMutations,
        mapGetters,
        mapActions,
        mapState
    } from "vuex";
export default {
  props: {
    chartName: { type: String, default: "新四化相关车型月度销量变化" }
  },
  data() {
    return {
      url:"#",
      tip: "12个月新四化相关车型的月度销量",
      chartId: "body_month_sales",
      chartOption: {},
      myChart: null,
      updated: "",
      marketType: "新四化整体",
      jsonData: [],
      loading: true,
      chartsData: [],
      current: {}
    };
  },
  mounted() {
    this.chartOption = {
        tooltip: {
                    formatter:function(params,ticket, callback){
                        return '日期:'+params.name+'<br />销量：'+params.value+' 辆'
                    }
                },
      title: {
        text: "单位：辆",
        show: false,

        right: "5%",
        top: "30%",
        textStyle: {
          fontWeight: "normal",
          color: "#6a7e97"
        }
      },
      legend: {
        orient: "vertical",
        right: "5%",
        top: "46%",
        show: false
      },

      grid: {
        left: "5%",
        right: "3%",
        bottom: "3%",
        containLabel: true
      },

      xAxis: {
        type: "category",
        boundaryGap: false, //坐标轴两边留白
        data: [
          "19.4",
          "19.5",
          "19.6",
          "19.7",
          "19.8",
          "19.9",
          "19.10",
          "19.11",
          "19.12",
          "20.1",
          "20.2",
          "20.3"
        ],
        axisLabel: {
          //坐标轴刻度标签的相关设置。
          interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
          //	margin:15,
          textStyle: {
            color: "#1B253A",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12
          },

           rotate:30,
        },
        axisTick: {
          //坐标轴刻度相关设置。
          show: false
        },
        axisLine: {
          //坐标轴轴线相关设置
          lineStyle: {
            color: "#E5E9ED"
            // opacity:0.2
          }
        },
        splitLine: {
          //坐标轴在 grid 区域中的分隔线。
          show: true,
          lineStyle: {
            color: "#E5E9ED"
            // 	opacity:0.1
          }
        }
      },
      yAxis: [
        {
          type: "value",

          axisLabel: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        }
      ],
      series: [
        {
          name: "MPV",
          type: "line",
          itemStyle: {
            normal: {
              color: "#3A84FF",
              lineStyle: {
                color: "#3A84FF",
                width: 1
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: "rgba(58,132,255,0)"
                  },
                  {
                    offset: 1,
                    color: "rgba(58,132,255,0.75)"
                  }
                ])
              }
            }
          },
          data: [22, 23, 33, 44, 46, 49, 34, 32, 45, 25, 35, 12]
        }
        // ,
        // {
        //   name: "SUV",
        //   type: "line",
        //   itemStyle: {
        //     normal: {
        //       color: "#183277",
        //       lineStyle: {
        //         color: "#183277",
        //         width: 1
        //       },
        //       areaStyle: {
        //         color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
        //           {
        //             offset: 0,
        //             color: "rgba(24,50,119,0)"
        //           },
        //           {
        //             offset: 1,
        //             color: "rgba(24,50,119,0.75)"
        //           }
        //         ])
        //       }
        //     }
        //   },
        //   data: [52, 22, 43, 41, 66, 42, 31, 21, 65, 35, 15, 22]
        // },
        // {
        //   name: "Sedan",
        //   type: "line",
        //   itemStyle: {
        //     normal: {
        //       color: "#7f7f7f",
        //       lineStyle: {
        //         color: "#7f7f7f",
        //         width: 1
        //       },
        //       areaStyle: {
        //         color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
        //           {
        //             offset: 0,
        //             color: "rgba(127,127,127,0)"
        //           },
        //           {
        //             offset: 1,
        //             color: "rgba(127,127,127,0.75)"
        //           }
        //         ])
        //       }
        //     }
        //   },
        //   data: [12, 18, 33, 32, 46, 72, 11, 41, 35, 45, 35, 12]
        // }
      ]
    };

    this.getChartList({
      handle: this.updateChart
    });
  },
  methods: {
    ...mapActions("home", [
      "queryChartConfigs",
      "queryChartUpdate",
      "getChartList",
      "queryChartBuild"
    ]),

    updateChart() {
      var self = this;
      this.myChart = echarts.init(document.getElementById("chart_btms"));
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });

      var info = this.getChartByName(this.chartId);
      this.url = info.url;
      if (info.updateOption == 2) {
        this.jsonData = eval(info.jsonData);
 
        this.bindChart();
      } else if (info.updateOption == 1) {
        var self = this;
        var postData = { chartName: this.chartId, noCache: false };
        this.queryChartBuild({
          params: postData,
          handle: function(res) {
            self.jsonData = res.data;
         
            self.bindChart();
          }
        });
      }
    },
      bindChart() {

             
                var max = this.jsonData.find(x=>x.t==this.marketType );
            
                this.jsonData.forEach(item => max = ( max.t== item.t && item.date > max.date) ? item : max);
               
                this.current = max;
                this.updated = `最新数据时间 ${strToYeayAndMonth(this.current.date)} `;       
                this.chartOption.xAxis.data = [];
                this.chartOption.series[0].data = [];

                var x = this.jsonData.filter(x => x.t == this.marketType);
                 
                for (var item of x) {
                     this.chartOption.xAxis.data.push(item.date.substring(2));
                     this.chartOption.series[0].data.push(item.value);
                }
                this.myChart.setOption(this.chartOption);
                this.loading = false;
            }
  },
  watch: {},
    computed: {
            ...mapGetters("home", {
                chartList: "chartList",
                getChartByName: "getChartByName"
            }),
    }
};
</script>
 